import React, { useState, useEffect } from 'react';
import { db, ref, set, auth } from '../Firebase/firebase-config'; 
import { onAuthStateChanged } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import { FaUser, FaEnvelope, FaPhone, FaCommentDots, FaPaperPlane } from 'react-icons/fa';
import './NeedHelp.css';

const NeedHelp = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [userId, setUserId] = useState(null);
  const [step, setStep] = useState(1); // Step for progressive input

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId(null);
      }
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && (isNaN(value) || value.length > 10)) return;
    setFormData({ ...formData, [name]: value });
  };

  const handleNextStep = () => {
    if (step < 4) setStep(step + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      alert('You must be logged in to submit a request.');
      return;
    }

    try {
      const helpId = uuidv4();
      const newRef = ref(db, `needHelp/${userId}/${helpId}`);
      await set(newRef, { ...formData, userId });
      alert('Your message has been sent!');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setStep(1);
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Error sending message. Please try again.');
    }
  };

  return (
    <div className="help-container">
      <div className="help-card">
        <h2 className="help-title">How can we help you? 🤔</h2>
        
        {step >= 1 && (
          <div className="help-input">
            <FaUser className="help-icon" />
            <input
              type="text"
              name="name"
              placeholder="What's your name?"
              value={formData.name}
              onChange={handleChange}
              required
              onKeyPress={(e) => e.key === 'Enter' && handleNextStep()}
            />
          </div>
        )}

        {step >= 2 && (
          <div className="help-input">
            <FaEnvelope className="help-icon" />
            <input
              type="email"
              name="email"
              placeholder="Your email address?"
              value={formData.email}
              onChange={handleChange}
              required
              onKeyPress={(e) => e.key === 'Enter' && handleNextStep()}
            />
          </div>
        )}

        {step >= 3 && (
          <div className="help-input">
            <FaPhone className="help-icon" />
            <input
              type="tel"
              name="phone"
              placeholder="Your phone number?"
              value={formData.phone}
              onChange={handleChange}
              required
              maxLength="10"
              onKeyPress={(e) => e.key === 'Enter' && handleNextStep()}
            />
          </div>
        )}

        {step >= 4 && (
          <div className="help-input message-box">
            <FaCommentDots className="help-icon" />
            <textarea
              name="message"
              placeholder="Type your message here..."
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
        )}

        {step < 4 ? (
          <button className="next-btn" onClick={handleNextStep}>
            Next ➡️
          </button>
        ) : (
          <button className="submit-btn" onClick={handleSubmit}>
            <FaPaperPlane /> Send Help Request
          </button>
        )}
      </div>
    </div>
  );
};

export default NeedHelp;
